import { render, staticRenderFns } from "./MyImage.vue?vue&type=template&id=67eb5fbf&scoped=true"
import script from "./MyImage.vue?vue&type=script&lang=js"
export * from "./MyImage.vue?vue&type=script&lang=js"
import style0 from "./MyImage.vue?vue&type=style&index=0&id=67eb5fbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67eb5fbf",
  null
  
)

export default component.exports